import { render, staticRenderFns } from "./CommodityUpload.vue?vue&type=template&id=55a873c8&scoped=true"
import script from "./CommodityUpload.vue?vue&type=script&lang=js"
export * from "./CommodityUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a873c8",
  null
  
)

export default component.exports